import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import React from 'react';

const ModalEliminar = ({
  handleCloseModal,
  idComponentToDelete,
  isOpen,
  onDeleteComponent,
}) => {
  return (
    <Dialog
      onClose={() => handleCloseModal()}
      aria-labelledby='simple-dialog-title'
      open={isOpen}
    >
      <DialogTitle id='simple-dialog-title'>Eliminar</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          <strong>¿Esta seguro que desea eliminar el componente?</strong> Se
          eliminarán las actividades y requerimientos pertenecientes a este
          componente
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={() => onDeleteComponent(idComponentToDelete)}
          color='secondary'
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEliminar;
